<template>
  <v-container>
    <div class="page-title">예약 접수</div>

    <v-row>
      <v-col cols="12" class="mt-3">
        <!-- 회원 정보 -->
        <span>{{stepTitle[0]}}</span>
        <v-divider class="mt-3"></v-divider>
        <c-card>
          <v-row justify="center">
            <div style="padding: 10px; width:800px">
              <customer-info
                :customerData.sync="customerData"
                :searchCustomerInfo="searchCustomerInfo"
                :customerObject.sync="customerObject"
              />
            </div>
          </v-row>
        </c-card>
        <v-divider class="mb-8"></v-divider>

        <!-- 예약 상세 정보 입력 -->
        <span>{{stepTitle[1]}}</span>
        <v-divider class="mt-3"></v-divider>
        <c-card>
          <reservation-info :reservationData.sync="reservationData"/>
        </c-card>
        <v-divider class="mb-8"></v-divider>


        <!-- 출발지 / 도착지 -->
        <span>{{stepTitle[2]}}</span>
        <v-divider class="mt-3"></v-divider>
        <c-card>
          <search-location :reservationData.sync="reservationData" :locationData.sync="locationData"
                           :commentsData.sync="commentsData" :customerData.sync="customerData" :fare-info="fareInfo"/>
        </c-card>
        <v-divider class="mb-8"></v-divider>

        <!-- 바우처 선택 -->
        <div v-if="this.$store.state.centerInfo.centerPay && this.$store.state.centerInfo.centerPay.configValue === 'cpm_voucher'">
          <span>바우처 선택</span>
          <v-divider class="mt-3"></v-divider>
          <c-card>
            <VoucherInfo :customerData="customerData" :voucherState.sync="voucherState"></VoucherInfo>
          </c-card>
          <v-divider class="mb-3"></v-divider>
        </div>

      </v-col>
    </v-row>
    <v-row justify="end">
      <c-btn class="mr-3" color="blue" @click="reqAddReservation">예약 접수</c-btn>
    </v-row>

    <!-- 예약 내용 확인 Dialog -->
    <v-dialog v-model="openFlag" persistent max-width="1800px">
      <c-card class="white">
        <reservation-check
          :reservationCheckData="reservationCheckData"
          :reservationType.sync="reservationType"
        />
        <v-divider class="mb-3 mt-3"></v-divider>
        <v-row justify="center" class="mb-4">
          <c-btn class="mr-3" outlined color="grey" @click="goToInit()">처음으로</c-btn>
          <c-btn class="mr-5" color="blue" @click="onReserve">배차 요청</c-btn>
        </v-row>
      </c-card>
    </v-dialog>



    <v-dialog
      v-model="autoDialogOpen"
      hide-overlay
      persistent
      width="300"
    >
      <c-card
        class="blue"
      >
        <v-card-text>
          <div class="py-6 text-center white--text">
            자동 배차 중입니다.
          </div>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
            height="10"
          ></v-progress-linear>
        </v-card-text>
      </c-card>
    </v-dialog>

    <manual-reserve-dialog
      :open.sync="manualDialogOpen"
      :reservationCheckData.sync="reservationCheckData"
      :reservationFlag.sync="manualReservationFlag"
    />

    <time-recommend-dialog
      :open.sync="timeRecoDialogFlag"
    />
  </v-container>
</template>
<script>
  import CustomerInfo from './CustomerInfo';
  import ReservationInfo from './ReservationInfo';
  import SearchLocation from './SearchLocation';
  import ReservationCheck from './ReservationCheck';
  import ManualReserveDialog from './ManualReserveDialog';
  import VoucherInfo from './VoucherInfo';
  import TimeRecommendDialog from "@/views/CallTaxi/Reserve/TimeRecommendDialog";

  export default {
    components: {
      TimeRecommendDialog,
      CustomerInfo, ReservationInfo, SearchLocation, ReservationCheck,
      ManualReserveDialog, VoucherInfo
    },
    data() {
      return {
        e1: 1,
        steps: 4,
        stepTitle: [
          '회원 조회 및 정보 입력',
          '예약 상세 정보 입력',
          '출발지 / 도착지 설정',
          '예약 접수 완료'
        ],
        fareInfo: {
          fareType: '',
          fareDetail: ''
        },

        searchCustomerInfo: null,

        customerData: null,
        reservationData: null,
        locationData: null,
        reservationCheckData: null,
        reservationType: 'auto',
        autoDialogOpen: false,
        manualDialogOpen: false,
        manualReservationFlag: null,
        commentsData: null,

        selectedDriverList: [],
        reservationUpdate: false,
        customerObject: {},
        originReservations: [],
        mobileNoRegx: /^(01[016789]|02|0[3-9][0-9])-[0-9]{3,4}-[0-9]{4}$/,
        voucherState : '',

        timeRecoDialogFlag: false,
      }
    },

    watch: {
      manualReservationFlag(newVal) {
        if (newVal) {
          this.$router.push(`/reservation/${this.reservationCheckData[0].reservationId}`);
        }
      }
    },

    mounted() {
      window.addEventListener('keydown', this.checkNextEvent);

      this.$event.$on('updateSelectedDriverList', (data) => {
        this.selectedDriverList = data;
      });
      const {path, params: {phoneNo, reservationId}, query: {n, p}} = this.$route;
      if (n || p) {
        console.log('n', n);
        console.log('p', p);
        // this.searchCustomerMobileNo = phoneNo;
        const decP = p ? atob(p).trim() : '';
        const decN = n ? decodeURI(n).trim() : '';
        this.searchCustomerInfo = decP + '|' + decN;
      } else if (reservationId) {
        this.reqGetReservationInfo(reservationId);
      }
    },
    destroyed() {
      window.removeEventListener('keydown', this.checkNextEvent);
    },
    methods: {
      checkNextEvent(e) {
        if (e.which === 13 && e.ctrlKey) {
          if (this.e1 < 3) {
            // const nextStep = this.e1 + 1;
            // this.e1 = nextStep;
            this.nextStep(this.e1);
          } else if (this.e1 === 3) {
            this.reqAddReservation();
          } else if (this.e1 === 4) {
            this.onReserve();
          }
          return;
        }
      },
      onReserve() {
        console.log('onReserve: ', this.reservationType);
        if (this.reservationType === 'auto') {
          this.reqAutoReservation()
        } else {
          this.manualDialogOpen = true;
        }
      },
      async reqAutoReservation() {
        let resvArray = this.reservationCheckData;
        const resvData = resvArray[0];

        try {
          this.autoDialogOpen = true; //로딩바
          let reqData = {
            reservationId: resvData.reservationId,
            centerId: this.$store.state.centerInfo.centerId
          };

          const res = await this.$api.autoReservation(reqData);
          if (res.data.length > 0) {
            this.autoDialogOpen = false;

            this.$store.commit('snackbar', {color: 'blue', timeout: 2000, msg: '예약이 완료되었습니다.'});
            await this.$router.push(`/reservation/${resvData.reservationId}`);
          } else {
            throw new Error('실패');
          }
        } catch (err) {

          this.autoDialogOpen = false;

          this.timeRecoDialogFlag = true;

          this.$store.commit('alert',
            {
              err, where: 'reqAutoReservation',
              open: true, persistent: true, msg: "자동배차에 실패했습니다.",
              callBack: () => {
                this.$router.push(`/reservation/${resvData.reservationId}`);
              }
            });
        }

      },
      async reqGetReservationInfo(reservationId) {
        try {
          this.reservationUpdate = true;
          const res = await this.$api.getReservation(reservationId);
          if (res.data.length === 0) {
            this.reservationUpdate = false;
            this.$store.commit('snackbar', {timeout: 2000, message: '예약정보가 없습니다.'});
            return;
          }

          // 같은 reservationId를 같는 모든 예약 리스트
          this.originReservations = res.data;

          const reservedInfo = res.data[0];
          if (reservedInfo.customerId !== null) {
            this.customerObject = reservedInfo.customerId;
          }
          //setCustomerData
          this.customerData = {
            id: reservedInfo.customerId ? reservedInfo.customerId.id : null,
            name: reservedInfo.customerName,
            mobileNo: reservedInfo.customerNo,
            familyNo: reservedInfo.familyNo,
            familyRelation: reservedInfo.familyRelation
          };

          this.reservationData = {
            selectedDate: this.$func.dateToString(reservedInfo.startTime), //moment().format('YYYY-MM-DD'),
            selectedTime: this.$moment(reservedInfo.startTime).format('HH:mm'), //'00:00',

            selectedCustomerCnt: reservedInfo.customerCnt,
            selectedCustomerCntInput: '',

            selectedCarCnt: reservedInfo.vehicleCnt,
            selectedCarTypeList: reservedInfo.vehicleType.split(','),
            selectedVehicleOption: reservedInfo.vehicleOption.split(','),

            selectedUse: reservedInfo.customerUsage,
            selectedUseInput: '', //위에가 없으면 채우기

            selectedLuggage: reservedInfo.luggage.split(','),
            selectedLuggageInput: '',

            selectedServiceTime: reservedInfo.serviceTime,
            selectedServiceInput: '',

            serviceComment: reservedInfo.customerComment,
          };

          this.locationData = {
            departure: reservedInfo.departure,
            destination: reservedInfo.destination,
            waypoint1: reservedInfo.waypoint1,
            waypoint2: reservedInfo.waypoint2,
            waypoint3: reservedInfo.waypoint3,
            driveTime: reservedInfo.driveTime, //ms
            departurePoint: reservedInfo.departurePoint,
            destinationPoint: reservedInfo.destinationPoint,
            waypoint1Point: reservedInfo.waypoint1Point,
            waypoint2Point: reservedInfo.waypoint2Point,
            waypoint3Point: reservedInfo.waypoint3Point,
            suburban: reservedInfo.suburban,
          };

          this.commentsData = {
            departureComment: reservedInfo.departureComment,
            destinationComment: reservedInfo.destinationComment,
            waypoint1Comment: reservedInfo.waypoint1Comment,
            waypoint2Comment: reservedInfo.waypoint2Comment,
            waypoint3Comment: reservedInfo.waypoint3Comment,
          }

          this.fareInfo = {
            fareType: reservedInfo.fareType,
            fareDetail: reservedInfo.fareDetail
          }

          this.voucherState = reservedInfo.voucherStateId ? reservedInfo.voucherStateId.id : '';

          this.reservedInfo = res.data;
        } catch (err) {
          this.$store.commit('snackbar', {err, where: 'reqGetReservationInfo'});
        }
      },
      async reqAddReservation() {
        try {
          const customerData = this.customerData;
          const locationData = this.locationData;
          const reservationData = this.reservationData;
          const commentsData = this.commentsData;
          const selectedVoucherState = this.voucherState;

          if (!customerData.name) {
            this.$store.commit('snackbar', {where: 'reqAddReservation', msg: '회원 이름을 입력해주세요.'});
            return;
          }

          // 예약 상세 정보 입력에서 일자 선택 시, 1. 잘못된 값을 입력했을 때(비어있는 필드가 있을 때)
          if (!this.reservationTimeCheck()) {
            this.$store.commit('snackbar', {where: 'reqAddReservation', msg: '출발 일시를 올바르게 입력해주세요.'});
            return;
          }

          // stepper에서 도착지 검색 후 text를 지운경우, 출발지 or 도착지를 입력하고 검색하지 않은 경우 snackbar show
          if (locationData === null || locationData.departure === null || locationData.destination === null) {
            console.log(locationData);
            this.$store.commit('snackbar', {where: 'reqAddReservation', msg: '출발지 / 도착지 검색을 완료해주세요.'});
            return;
          }
          const serviceTime = reservationData.selectedServiceTime === -1 ? parseInt(reservationData.selectedServiceInput) : reservationData.selectedServiceTime;
          const driveTime = locationData.driveTime;
          const startTime = this.$moment(reservationData.selectedDate + ' ' + reservationData.selectedTime).format('YYYY-MM-DD HH:mm:ss');
          const arriveTime = this.$moment(startTime).add(driveTime, 'ms').format('YYYY-MM-DD HH:mm:ss');
          const endTime = this.$moment(arriveTime).add(serviceTime, 'm').format('YYYY-MM-DD HH:mm:ss');

          if (reservationData.selectedLuggage.indexOf(-1) > -1) {
            let idx = reservationData.selectedLuggage.indexOf(-1);
            reservationData.selectedLuggage.splice(idx, 1, reservationData.selectedLuggageInput)
          }

          let reqData = {
            customerId: customerData.id,
            customerName: customerData.name,
            mobileNo: customerData.mobileNo,
            familyNo: customerData.familyNo,
            familyRelation: customerData.familyRelation,

            departure: locationData.departure,
            departurePoint: locationData.departurePoint,
            destination: locationData.destination,
            destinationPoint: locationData.destinationPoint,
            waypoint1: locationData.waypoint1,
            waypoint1Point: locationData.waypoint1Point,
            waypoint2: locationData.waypoint2,
            waypoint2Point: locationData.waypoint2Point,
            waypoint3: locationData.waypoint3,
            waypoint3Point: locationData.waypoint3Point,

            customerCnt: reservationData.selectedCustomerCnt === -1 ? parseInt(reservationData.selectedCustomerCntInput) : reservationData.selectedCustomerCnt,
            vehicleCnt: reservationData.selectedCarCnt,
            vehicleType: reservationData.selectedCarTypeList.join(),
            vehicleOption: reservationData.selectedVehicleOption.join(),
            customerUsage: reservationData.selectedUse === -1 ? reservationData.selectedUseInput : reservationData.selectedUse,
            luggage: reservationData.selectedLuggage.join(),
            serviceTime: serviceTime,
            customerComment: reservationData.serviceComment ? reservationData.serviceComment : '',
            startTime: startTime,

            arriveTime: arriveTime,
            endTime: endTime,
            driveTime: driveTime,
            suburban: locationData.suburban.configValue,

            departureComment: commentsData !== null && commentsData.departureComment ? commentsData.departureComment : '',
            destinationComment: commentsData !== null && commentsData.destinationComment ? commentsData.destinationComment : '',
            waypoint1Comment: commentsData !== null && commentsData.waypoint1Comment ? commentsData.waypoint1Comment : '',
            waypoint2Comment: commentsData !== null && commentsData.waypoint2Comment ? commentsData.waypoint2Comment : '',
            waypoint3Comment: commentsData !== null && commentsData.waypoint3Comment ? commentsData.waypoint3Comment : '',

            voucherId : selectedVoucherState, //voucherStateId
          };

          let res = [];


          //예약 변경
          if (this.reservationUpdate) {
            let customerId = null;
            if (this.customerData.id !== null) {
              customerId = this.customerObject;
            }

            let reservationUpdateReq = [];

            let reqDataForUpdate = this.originReservations.map(item => {

              let data = {...reqData};
              data.centerId = item.centerId;
              data.id = item.id;
              data.reservationId = item.reservationId;
              data.suburban = this.locationData.suburban;
              if (this.customerData.id !== null) {
                data.customerId = this.customerObject;
              }
              data.resrvState = {
                configKey: 'reserv_state',
                configName: '배차대기',
                configValue: 'rs_receipt',
              };
              data.created = item.created;
              data.customerNo = customerData.mobileNo;
              data.driverSafenNo = item.driverSafenNo;
              // data.customerNo = item.mobileNo;

              data.fareType = item.fareType;
              data.fareDetail = item.fareDetail;
              console.log('data', data);

              return data;
            });
            reservationUpdateReq = reqDataForUpdate;

            if (this.originReservations[0].vehicleCnt > reservationData.selectedCarCnt) {
              console.log('2 -> 1')
              let arr = [];
              arr.push(reservationUpdateReq[0])
              reservationUpdateReq = arr;

            } else if (this.originReservations[0].vehicleCnt < reservationData.selectedCarCnt) {
              console.log('1 -> 2')

              let newReservation = {...reqDataForUpdate[0]};
              newReservation.id = null;
              reservationUpdateReq.push(newReservation);

            }

            res = await this.$api.updateReservation(reservationUpdateReq);

            if (this.originReservations[0].vehicleCnt > reservationData.selectedCarCnt) {
              // 차량을 2 -> 1 로 변경 : 둘 중 하나의 reservation은 cancel
              this.originReservations[1].reservationId = null;
              this.originReservations[1].resrvState = {
                configKey: 'reserv_state',
                configName: '정상취소',
                configValue: 'rs_cancel'
              };
              let req = [];

              req.push(this.originReservations[1])
              const cancelRes = await this.$api.addCanceledReservation(req);
              console.log('cancel Res', cancelRes);

              const deleteRes = await this.$api.deleteReservationByIdAndResvId(this.originReservations[1].id)
              console.log('delete Res', deleteRes);
            }
          } else {
            res = await this.$api.addReservation(reqData);

          }
          if (res.data && res.data.length > 0) {
            this.reservationCheckData = res.data;
            this.e1 += 1;

            this.openFlag = true;

          } else {
            this.$store.commit('snackbar', {msg: '예약접수에 실패하였습니다. 잠시후 다시 시도해 주세요.'});
          }

        } catch (err) {
          this.$store.commit('snackbar', {err, where: 'reqAddReservation', msg: '문제가 발생하였습니다. 잠시후 다시 시도해주세요.'});
        }
      },
      initData() {
        this.e1 = 1;
        this.customerData = null;
        this.reservationData = null;
        this.locationData = null;
        this.selectedDriverList = [];
        this.commentsData = null;

        console.log('1', this.customerData);
        console.log('2', this.locationData);
        console.log('3', this.reservationData);
        console.log('4', this.commentsData);

       this.openFlag = false;
      },
      validate(value) {
        if (value === null) return false;
        return !value || (typeof value === 'string') ? (value.trim().length === 0 ? false : true) : true;
      },
      nextStep(n) {
        switch (n) {
          case 1:
            const customerData = this.customerData;
            console.log('in switch', customerData);
            if (!customerData || !this.validate(customerData.mobileNo) || !this.validate(customerData.name)) {
              this.$store.commit('snackbar', {timeout: 2000, msg: '비어있는 필드가 있습니다.'});
              return;
            }

            // if(!this.mobileNoRegx.test(customerData.mobileNo)) {
            //   this.$store.commit('snackbar', {timeout : 2000 ,msg: '연락처 양식이 올바르지 않습니다.'});
            //   return;
            // }

            if (!customerData.id) customerData.id = null;
            break;

          case 2:
            const reservationData = this.reservationData;
            const startTime = this.$moment(reservationData.selectedDate + ' ' + reservationData.selectedTime).format('YYYY-MM-DD HH:mm:ss');
            if (startTime < this.$func.curDateTimeString) {
              this.$store.commit('snackbar', {where: 'reqAddReservation', msg: '과거 시간은 예약이 불가능합니다. 시간을 다시 설정해주세요.'});
              return;
            }

            if (!reservationData
              || (reservationData.selectedCustomerCnt === -1 && !this.validate(reservationData.selectedCustomerCntInput))
              || (reservationData.selectedServiceTime === -1 && !this.validate(reservationData.selectedServiceInput))
              || (reservationData.selectedUse === -1 && !this.validate(reservationData.selectedUseInput))
              || (!reservationData.selectedCarTypeList || reservationData.selectedCarTypeList.length < 1)
            ) {
              this.$store.commit('snackbar', {timeout: 2000, msg: '비어있는 필드가 있습니다.'});
              return;
            }

            // 기타 인원수 입력시 5명 이상만 입력 가능하도록
            if (reservationData.selectedCustomerCnt === -1 && reservationData.selectedCustomerCntInput < 5) {
              this.$store.commit('snackbar', {timeout: 2000, msg: '입력 값을 확인해주세요.'});
              return;
            }

            break;

          case 3:
            const locationData = this.locationData;
            if (!locationData || !this.validate(locationData.departure) || !this.validate(locationData.destination)) {
              this.$store.commit('snackbar', {timeout: 2000, msg: '비어있는 필드가 있습니다.'});
              return;
            }
            break;

          case 4:
            break;
        }

        if (n === this.steps) {
          this.e1 = 1
        } else {
          this.e1 = n + 1
        }
      },
      goToInit() {
        // 데이터 초기화
        this.initData();
        this.openFlag = false;
        // this.$router.push('/testReserve');
        window.location.href = '/testReserve';
      },
      reservationTimeCheck() {
        let reserveTime = this.reservationData.selectedTime.split(":");
        const hour = reserveTime[0];
        const minute = reserveTime[1];

        return (hour >= 7 && hour <= 23 && minute >= 0 && minute <= 59);
      },
    },
    beforeDestroy() {
      this.$event.$off('event_name');
    }
  }
</script>
<style lang="scss">
  .rsv-stepper {
    background-color: rgba(0, 0, 0, 0) !important;
    box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0), 0px 2px 2px 0px rgba(0, 0, 0, 0), 0px 1px 5px 0px rgba(0, 0, 0, 0) !important;
  }

  .rsv-stepper__content {
  }

  .rsv-stepper__header {
    background-color: white;
  }
</style>
